import { LectureWithScheduleMetadata } from '../../../../../../../api/types/programs/course/lectures/lecture-with-schedule-metadata';
import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import globalCourseStore from '../../../../../../../stores/global-course-store';
import globalLectureBuilderStore from '../../../../../../../stores/global-lecture-builder-store';
import { UserAttendanceRequest } from '../../../../../../../api/types/lecturers/attendance/user-attendance-request';

export const updateAttendanceOperations = async (
  programId: number | undefined,
  lecture: LectureWithScheduleMetadata | null,
  sessions: {
    attendanceSessionsId: number;
    attendance: UserAttendanceRequest[];
  }[],
) => {
  try {
    if (!lecture) {
      toast.warn('לא ניתן לבצע את הפעולה המבוקש, נסה שוב בעוד מספר רגעים');
      return;
    }

    if (isNaN(Number(programId))) {
      toast.warn(
        'לא ניתן לאתר את מזהה הקורס ו/או התוכנית כעת, נסה שוב בעוד מספר רגעים',
      );
      return;
    }

    if (sessions.length === 0) {
      toast.info('לא נמצאו שינויים לעדכון');
      return;
    }

    const res = await appApi.upsetLectureAttendance(
      programId!,
      lecture.item.courseId,
      lecture.item.id,
      sessions,
    );

    const currentCourse = globalCourseStore.getCurrentCourse();
    if (currentCourse?.details) {
      currentCourse.details.lectures = res.data.body;
    }

    globalLectureBuilderStore.selectedLecture = null;

    toast.success('הפעולה בוצעה בהצלחה');
  } catch (e) {}
};
